import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function getRefDokter(nama: string) {
  const response = await http
    .getData(`/dokter?nama=${nama}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

export default {
  getRefDokter
};
